import React from "react";
import Select from "react-select";
import {Sample} from "../../types/Sample";
import {parseDate} from "../../util/FormatUtil";
import {sweetalert} from "../../App";
import moment from "moment";
import DatePicker from 'react-datepicker'
import TestType from "../../types/TestType";
import Validator from "../../validation/Validator";
import {Validators} from "../../validation/Validators";
import AdminAPI from "../../network/AdminAPI";


interface RapidTestState{
    results:{value, label}[]
    selectedResult?
    PatientInformed?
    PatientDOB?
}

interface RapidTestProps{
    tests?:TestType[]
    selectedPatient:Sample
    onSubmit
}

export class RapidTestModal extends React.Component<RapidTestProps, RapidTestState>{

    constructor(props) {
        super(props);
        this.state={
            results:[],
        }
    }

    public static display(){
        window["$"]("#" + RapidTestModal.ID).modal('show');
    }

    public submit(){

        let formValidation = {
            SelectedResult: this.state.selectedResult,
            PatientInformed: this.state.PatientInformed
        }
        let validator = new Validator<any>()
            .withSimpleValidation("SelectedResult", Validators.requireNonNullValidator("Test Result"))
            .withSimpleValidation("PatientInformed", Validators.requireNonNullValidator("Patient Informed"))

        let validationResponse = validator.validate(formValidation);
        if(!validationResponse.success) {
            return sweetalert.fire({icon: 'error', title: '', text: validationResponse.error});
        }
        this.props.onSubmit({
            resultID: this.state.selectedResult.value,
            PatientInformed: this.state.PatientInformed ? this.state.PatientInformed.value : false
        });
    }

    componentDidMount() {
        AdminAPI.getAllResultTypes().then(data => {
            this.setState({results: data} as any)
        })
    }

    componentWillReceiveProps(nextProps: Readonly<RapidTestProps>, nextContext: any) {


        //!!! ASSUMING THAT THERE IS ONLY ONE TEST AND ONE RESULT FOR RAPID TESTS// 
        if(nextProps.selectedPatient.ResultIDs){
            let resultIDs = JSON.parse(nextProps.selectedPatient.ResultIDs)
            this.setState({selectedResult:this.state.results.find(f => f.value === resultIDs[0]), PatientInformed:""})
        }else{
            this.setState({selectedResult:"", PatientInformed:""})
        }

        if(nextProps.selectedPatient.PatientDOB){
            this.setState({PatientDOB: parseDate(nextProps.selectedPatient.PatientDOB)})
        }
    }

    handleDateOnChange(value, state){
        if (value) {
            this.setState({[state]: value } as any);
        }
        else{
            this.setState({[state]: null} as any)
        }
    }

    public static ID = "rapidTest"
    render() {

        // console.log('RapidTestModal state', this.state)
        // console.log('RapidTestModal props', this.props)

        let testIDs = this.props.selectedPatient && this.props.selectedPatient.TestIDs ? JSON.parse(this.props.selectedPatient.TestIDs) : null
        let foundTest:TestType = testIDs && testIDs.length > 0 ? this.props.tests?.find(t => t.ID === testIDs[0]) : null;
        let validResults = [];
        if(foundTest){
            validResults = this.state.results.filter(r => foundTest.ValidResults.find(v => v.ID === r.value));
        }
      
        return <React.Fragment>
            <div className="modal fade form_modal" id={RapidTestModal.ID} tabIndex={-1} role="dialog"
                 aria-labelledby="result_modal_label"
                 aria-hidden="true">
                <div className="modal-dialog modal-lg modal-xl" role="document">
                    <div className="modal-content">
                    <div className="container-fluid">
                        <div className="modal-header">
                            <h5 className="modal-title" id="result_modal_label">Test Completion</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body mr-3">
                            <div className="form-group row">
                                <label htmlFor={"FirstName"} className={"col-sm-4 col-form-label"}>First Name</label>
                                <div className={"col-sm-8 p-0 m-0"}>
                                    <input type={"search"} className="form-control" readOnly={true} id={"FirstName"}
                                           value={this.props.selectedPatient.PatientFirstName}/>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor={"LastName"} className={"col-sm-4 col-form-label"}>Last Name</label>
                                <div className={"col-sm-8 p-0 m-0"}>
                                    <input type={"search"} className="form-control" readOnly={true} id={"LastName"}
                                           value={this.props.selectedPatient.PatientLastName}/>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor={"DOB"} className={"col-sm-4 col-form-label"}>DOB</label>
                                <div className={"col-sm-8 p-0 m-0"}>
                                    <DatePicker
                                        id={"DOB"}
                                        readOnly
                                        minDate={new Date('01-01-1000')}
                                        maxDate={new Date('12-31-9999')}
                                        placeholderText="--/--/----"
                                        selected={this.state.PatientDOB ? Date.parse(moment(this.state.PatientDOB, 'MM-DD-YYYY').toISOString()) : null}
                                    />

                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor={"SpecimenID"} className={"col-sm-4 col-form-label"}>Specimen ID</label>
                                <div className={"col-sm-8 p-0 m-0"}>
                                    <input type={"search"} className="form-control" readOnly={true} id={"SpecimenID"}
                                           value={this.props.selectedPatient.SpecimenID}/>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor={"Test Result"} className={ "col-sm-4 col-form-label"}>Test Result</label>
                                    <div className={"col-sm-8 p-0 m-0 "} id={"Test Result"}>

                                    <Select
                                        placeholder={"Please Select..."}
                                        value={this.state.selectedResult}
                                        onChange={(e)=>{
                                            this.setState({selectedResult:e})
                                        }}
                                        className={"state_select"}
                                        options={validResults}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor={"Patient Informed"} className={ "col-sm-4 col-form-label"}>Patient Informed?</label>
                                    <div className={"col-sm-8 p-0 m-0 "} id={"Patient Informed"}>

                                    <Select
                                        placeholder={"Please Select..."}
                                        value={this.state.PatientInformed}
                                        onChange={(e)=>{
                                            this.setState({PatientInformed:e})
                                        }}
                                        className={"state_select"}
                                        options={[{label:"Yes", value:true}, {label:"No", value:false}]}
                                    />
                                </div>
                            </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" onClick={() => this.submit()}>
                                    Submit
                                </button>
                            </div>
                        
                    </div>
                </div>
                </div>
            </div>
        </React.Fragment>;
    }
}